var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 164,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M92.64 6.15 9.75 3.348c-1.895-.065-3.435 1.404-3.435 3.28v150.54c0 1.876 1.54 3.31 3.435 3.198l82.89-4.715c1.712-.1 3.105-1.616 3.105-3.398V9.478c-.006-1.782-1.393-3.269-3.104-3.328Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DEE8",
    d: "M58.629 117.316C57.218 100.104 67.794 93 63.763 77.405c-4.987-19.277-24.156-20.103-30.69-39.008-2.502-7.246-3.487-18.192 3.672-34.135L9.75 3.348c-1.895-.065-3.435 1.404-3.435 3.28v150.54c0 1.876 1.54 3.31 3.435 3.198l73.908-4.201c-18.803-14.557-24.162-28.27-25.03-38.849Z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M92.64 8.05 9.75 5.342a1.35 1.35 0 0 0-1.411 1.345V157.05c0 .767.631 1.357 1.41 1.316l82.891-4.615c.703-.041 1.275-.666 1.275-1.392V9.419c0-.731-.572-1.345-1.275-1.369Z",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m76.984 121.883-50.296 1.811a2.243 2.243 0 0 0-2.148 2.225 2.05 2.05 0 0 0 2.148 2.065l50.296-1.936c1.115-.041 2.024-1.009 2.024-2.159 0-1.151-.909-2.048-2.024-2.006Z",
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m76.984 129.3-50.296 2.036a2.257 2.257 0 0 0-2.148 2.236c0 1.186.962 2.106 2.148 2.053l50.296-2.159c1.115-.048 2.024-1.021 2.024-2.166 0-1.15-.909-2.047-2.024-2Z",
    opacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m76.984 136.717-50.296 2.26a2.267 2.267 0 0 0-2.148 2.242c0 1.186.962 2.101 2.148 2.047l50.296-2.383c1.115-.054 2.024-1.027 2.024-2.178 0-1.15-.909-2.041-2.024-1.988Z",
    opacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m50.903 14.075-25.301-.714a1.031 1.031 0 0 0-1.068 1.032c0 .585.478 1.074 1.068 1.092l25.301.684a1.006 1.006 0 0 0 1.033-1.02 1.07 1.07 0 0 0-1.033-1.074Z",
    opacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m50.903 17.804-25.301-.661a1.031 1.031 0 0 0-1.068 1.032c0 .585.478 1.074 1.068 1.092l25.301.631a1.01 1.01 0 0 0 1.033-1.02c0-.585-.46-1.063-1.033-1.074Z",
    opacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "m50.903 21.527-25.301-.608a1.036 1.036 0 0 0-1.068 1.039c0 .584.478 1.074 1.068 1.085l25.301.573a1.01 1.01 0 0 0 1.033-1.021c0-.572-.46-1.05-1.033-1.068Z",
    opacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.818 117.31c-1.411-17.212 9.165-24.316 5.134-39.906-4.981-19.276-24.15-20.102-30.683-39.002-2.396-6.945-3.406-17.294 2.827-32.193L9.945 5.353A1.35 1.35 0 0 0 8.535 6.7v150.345c0 .767.63 1.357 1.41 1.315l71.648-3.988c-16.986-13.902-21.943-26.924-22.775-37.061Z",
    opacity: 0.35
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M141.808 39.382c1.741.885 3.931.071 4.887-1.811.956-1.883.325-4.13-1.416-5.016-.089-.047-.183-.082-.278-.124.325-1.044.567-2.094.732-3.144.1 0 .201 0 .301-.012 1.989-.177 3.565-2 3.523-4.078-.041-2.077-1.688-3.61-3.671-3.434a4.78 4.78 0 0 0-.306.042 20.113 20.113 0 0 0-.85-3.004c.088-.053.183-.106.271-.17 1.7-1.193 2.243-3.541 1.216-5.246-1.027-1.706-3.24-2.13-4.94-.939-.088.06-.171.13-.248.195a18.21 18.21 0 0 0-2.201-2.06c.053-.093.112-.182.159-.282.956-1.883 2.207-3.942.455-4.797-4.061-1.983-5.802-.284-6.758 1.599-.047.1-.094.194-.136.295a18.207 18.207 0 0 0-2.962-.567c.006-.106.011-.212.011-.318-.041-2.077.573-3.199-1.422-3.234-4.35-.083-5.813 1.8-5.772 3.877 0 .106.012.212.024.318-.998.284-1.977.65-2.928 1.086a3.93 3.93 0 0 0-.147-.271c-1.027-1.706-3.24-2.125-4.94-.939-1.7 1.192-2.243 3.54-1.216 5.246.053.088.112.171.171.248a21.597 21.597 0 0 0-2.106 2.448 2.342 2.342 0 0 0-.26-.147c-1.741-.885-3.931-.07-4.887 1.811-.956 1.883-.324 4.13 1.417 5.016.088.047.183.082.277.124a22.142 22.142 0 0 0-.732 3.145c-.1 0-.201 0-.301.011-1.989.177-3.565 2-3.523 4.078.041 2.077 1.688 3.61 3.671 3.434a4.91 4.91 0 0 0 .307-.041c.206 1.026.489 2.03.849 3.003-.088.053-.183.106-.271.171-1.7 1.192-2.243 3.54-1.216 5.246 1.027 1.705 4.438 2.501 6.138 1.31.089-.06-1.027-.502-.944-.567a18.203 18.203 0 0 0 2.201 2.06c-.053.094-.112.182-.159.282-.956 1.883-.325 4.13 1.416 5.016 1.741.885 3.931.07 4.887-1.811.047-.1.094-.195.136-.295.973.27 1.965.46 2.962.566a5.654 5.654 0 0 0-.011.319c.041 2.076 1.688 3.61 3.671 3.434 1.988-.177 3.564-2 3.523-4.078 0-.106-.012-.212-.024-.318.998-.283 1.977-.65 2.928-1.086.047.095.094.183.147.272 1.027 1.705 3.24 2.13 4.94.938 1.7-1.192 2.243-3.54 1.216-5.246a2.597 2.597 0 0 0-.171-.248 21.707 21.707 0 0 0 2.107-2.448c.076.047.159.094.253.141Zm-21.707.278c-6.32-3.21-8.628-11.359-5.152-18.203 3.476-6.845 11.414-9.79 17.741-6.58 6.321 3.21 8.628 11.359 5.152 18.203-3.476 6.84-11.42 9.79-17.741 6.58Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M146.028 29.28c1.989-.177 3.565-2 3.523-4.077-.041-2.077-1.688-3.611-3.671-3.434a4.78 4.78 0 0 0-.306.041 20.117 20.117 0 0 0-.85-3.003c.088-.053.183-.106.271-.171 1.7-1.192 3.801-4.066 2.603-5.659-2.278-3.02-4.633-1.717-6.333-.525-.088.059-.171.13-.248.195a18.137 18.137 0 0 0-2.201-2.06c.053-.094.112-.182.159-.283.52-1.027.567-2.16.225-3.115a572.675 572.675 0 0 0-4.852 8.703c5.04 3.694 6.652 10.975 3.494 17.182-2.673 5.258-7.979 8.214-13.167 7.842-.23.602-.46 1.204-.708 1.794-.673 1.61-1.434 3.192-2.201 4.767.478.089.962.16 1.446.213a5.652 5.652 0 0 0-.012.318c.041 2.077 1.298 3.836 4.898 3.647 1.989-.106 2.331-2.213 2.29-4.284 0-.106-.012-.212-.023-.319a20.3 20.3 0 0 0 2.927-1.085c.047.094.094.183.147.271 1.027 1.706 4.598 2.431 6.298 1.245 1.699-1.192.885-3.847-.148-5.552a2.597 2.597 0 0 0-.171-.248 21.622 21.622 0 0 0 2.107-2.449c.083.053.171.107.26.148 1.741.885 3.93.07 4.886-1.812.956-1.882.325-4.13-1.422-5.015-.089-.047-.183-.083-.277-.124.324-1.044.566-2.095.731-3.145.124.006.225.006.325-.006Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M143.679 39.594c1.741.886 3.931.071 4.887-1.811.956-1.882.325-4.13-1.422-5.016-.089-.047-.183-.082-.278-.123.325-1.045.567-2.095.732-3.145.101 0 .201 0 .301-.012 1.989-.177 3.565-2 3.524-4.077-.042-2.077-1.688-3.611-3.671-3.434a4.717 4.717 0 0 0-.307.04 20.117 20.117 0 0 0-.85-3.003c.088-.053.183-.106.271-.17 1.7-1.193 2.243-3.541 1.216-5.246-1.027-1.705-3.24-2.13-4.94-.938-.088.059-.171.13-.248.194a18.145 18.145 0 0 0-2.201-2.059c.053-.094.112-.183.159-.283.957-1.882.325-4.13-1.416-5.016-1.741-.885-3.931-.07-4.887 1.812-.047.1-.094.195-.135.295a18.24 18.24 0 0 0-2.963-.567c.006-.106.012-.212.012-.318-.042-2.077-1.688-3.611-3.671-3.434-1.989.177-3.565 2-3.524 4.077 0 .106.012.212.024.319-.997.283-1.977.649-2.927 1.085a4.417 4.417 0 0 0-.148-.271c-1.027-1.705-3.24-2.13-4.94-.938-1.699 1.192-2.242 3.54-1.215 5.245.053.089.112.171.171.248a21.521 21.521 0 0 0-2.107 2.449 2.255 2.255 0 0 0-.26-.148c-1.741-.885-3.931-.07-4.887 1.812-.956 1.882-.324 4.13 1.417 5.015.088.047.183.083.277.124a22.419 22.419 0 0 0-.732 3.145c-.1 0-.2 0-.301.012-1.989.177-3.564 2-3.523 4.077.041 2.077 1.688 3.611 3.671 3.434a4.91 4.91 0 0 0 .307-.041c.206 1.026.49 2.03.85 3.003-.089.053-.183.106-.272.171-1.7 1.192-2.242 3.54-1.216 5.246 1.027 1.705 3.241 2.13 4.94.938.089-.059.171-.13.248-.195a18.286 18.286 0 0 0 2.201 2.06c-.053.094-.112.183-.159.283-.956 1.882-.324 4.13 1.417 5.015 1.741.885 3.93.071 4.886-1.811.047-.1.095-.195.136-.295.974.271 1.965.46 2.963.566-.006.106-.012.213-.012.319.041 2.077 1.688 3.611 3.671 3.434 1.989-.177 3.565-2 3.523-4.077 0-.107-.012-.213-.023-.319.997-.283 1.977-.649 2.927-1.086.047.095.094.183.147.272 1.027 1.705 3.241 2.13 4.94.938 1.7-1.192 2.243-3.54 1.216-5.246a2.597 2.597 0 0 0-.171-.247 21.614 21.614 0 0 0 2.107-2.45c.088.054.177.107.265.148Zm-21.706.278c-6.321-3.21-8.629-11.359-5.153-18.203 3.476-6.845 11.414-9.79 17.741-6.58 6.321 3.21 8.629 11.36 5.152 18.204-3.476 6.838-11.414 9.789-17.74 6.579Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M90.433 137.702c-4.479-.077-8.551-10.455-8.905-18.935-.136-3.28-.272-6.543 1.623-9.83 3.199-5.546 8.115-4.089 10.983-8.609 4.237-6.673-3.523-14.485.69-20.032 3.099-4.077 8.287-1.139 12.046-5.617 4.362-5.198.106-12.391 4.143-15.011 2.349-1.522 4.403.502 11.155-1.033 2.644-.601 3.96-.902 5.069-1.823 3.884-3.245.915-8.762 3.789-12.869 3.164-4.52 11.515-4.62 16.708-3.192 9.307 2.555 14.737 11.713 16.065 19.454.283 1.658 1.971 12.485-4.91 19.424-5.005 5.045-12.618 6.09-13.852 6.26-4.81.662-5.984-.583-7.537.691-4.473 3.67 4.297 14.929-.779 23.762-2.071 3.605-6.143 6.266-9.997 7.039-6.233 1.257-9.632-2.862-12.73-.791-4.002 2.679-.083 10.757-4.427 13.99-3.075 2.284-6.197-.897-11.609 1.47-4.798 2.082-4.869 5.694-7.525 5.652Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FA",
    d: "M89.465 129.796c2.066.182 2.29-5.382 7.991-13.53 6.221-8.898 10.358-8.55 16.189-16.593 6.657-9.175 2.579-11.44 8.233-18.621 7.666-9.736 15.946-6.586 25.201-18.033 2.779-3.434 6.456-8.113 4.992-12.94-1.268-4.183-6.232-7.918-11.095-7.18-.201.03-4.285.72-6.403 4.26-2.603 4.349.767 7.93-1.747 11.311-1.316 1.77-3.713 2.325-8.505 3.428-6.893 1.588-8.28.29-9.992 1.86-3.865 3.54 1.771 11.487-2.053 15.736-3.282 3.646-9.39-.042-12.229 3.404-3.423 4.16 4.013 11.3.832 17.855-2.738 5.647-9.809 3.558-13.733 9.618-4.64 7.157-.667 19.159 2.32 19.425Z",
    opacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M109.638 153.362c3.806-.095 3.665-7.087 10.068-9.789 7.082-2.986 12.364 3.416 17.204.324 5.441-3.475 1.281-13.158 7.342-17.512 4.143-2.974 7.554.495 12.842-2.378 5.518-2.992 10.387-11.406 7.448-18.929-2.449-6.278-9.472-9.742-14.819-9.276-4.374.378-5.365 3.193-9.26 2.756-4.857-.543-5.176-5.11-10.358-6.697-5.158-1.576-11.78.832-15.132 5.24-2.792 3.664-2.709 7.912-2.638 11.612.189 9.942 5.052 13.323 3.004 17.341-2.556 5.016-11.166 1.782-14.471 6.827-4.138 6.32 3.299 20.617 8.77 20.481Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FA",
    d: "M107.124 146.27c1.41.147 1.393-4.39 5.388-8.556 4.58-4.78 8.54-2.921 13.793-6.851 6.515-4.868 3.387-9.918 9.136-14.774 8.062-6.804 19.393-1.257 21.825-6.42 1.422-3.021-.968-8.049-4.179-9.465-3.429-1.51-5.412 2.154-11.078 1.865-5.305-.272-5.919-3.6-12.535-4.68-3.228-.524-7.466-1.215-9.921 1.057-4.804 4.455-.661 18.356.608 22.605 1.163 3.906 2.042 5.381 1.157 7.098-2.314 4.496-11.727.968-15.457 5.942-3.122 4.16-.561 11.996 1.263 12.179Z",
    opacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M107.702 2.923 21.282.002C19.305-.063 17.7 1.465 17.7 3.418v156.954c0 1.953 1.605 3.446 3.582 3.334l86.426-4.916c1.788-.1 3.234-1.687 3.234-3.54V6.392c-.006-1.853-1.451-3.404-3.24-3.47Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DEE8",
    d: "M72.244 118.826c-1.47-17.949 9.555-25.354 5.353-41.616-5.2-20.097-25.189-20.958-31.993-40.666-2.61-7.553-3.642-18.97 3.83-35.586L21.282.002C19.305-.063 17.7 1.465 17.7 3.418v156.954c0 1.953 1.605 3.446 3.582 3.334l77.06-4.379c-19.606-15.176-25.195-29.473-26.098-40.501Z",
    opacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "m107.702 4.906-86.42-2.82a1.408 1.408 0 0 0-1.47 1.404v156.77c0 .803.662 1.416 1.47 1.369l86.426-4.815c.732-.041 1.328-.696 1.328-1.457V6.334c-.006-.761-.602-1.405-1.334-1.428Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DEE8",
    d: "m91.377 123.588-52.437 1.888c-1.24.048-2.243 1.086-2.243 2.319a2.14 2.14 0 0 0 2.243 2.154l52.438-2.018c1.162-.047 2.106-1.05 2.106-2.248.006-1.198-.938-2.136-2.106-2.095ZM91.377 131.324l-52.437 2.124a2.35 2.35 0 0 0-2.243 2.331 2.126 2.126 0 0 0 2.243 2.142l52.438-2.254c1.162-.048 2.106-1.063 2.106-2.26.006-1.198-.938-2.13-2.106-2.083ZM91.377 139.053l-52.437 2.355a2.365 2.365 0 0 0-2.243 2.342 2.113 2.113 0 0 0 2.243 2.13l52.438-2.49c1.162-.053 2.106-1.068 2.106-2.265.006-1.192-.938-2.125-2.106-2.072ZM64.188 11.184l-26.381-.75a1.071 1.071 0 0 0-1.11 1.074c0 .614.496 1.121 1.11 1.139l26.38.714a1.046 1.046 0 0 0 1.075-1.062c0-.596-.478-1.098-1.074-1.115ZM64.188 15.072l-26.381-.69a1.072 1.072 0 0 0-1.11 1.08c0 .613.496 1.12 1.11 1.132l26.38.655a1.046 1.046 0 0 0 1.075-1.062 1.11 1.11 0 0 0-1.074-1.115ZM64.188 18.96l-26.381-.63a1.08 1.08 0 0 0-1.11 1.079c0 .614.496 1.121 1.11 1.133l26.38.596a1.054 1.054 0 0 0 1.075-1.068c0-.596-.478-1.098-1.074-1.11Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M54.025 60.713c1.712-3.24 4.916-5.54 8.676-5.971l.26-16.009c-10.706.284-19.925 6.88-24.056 16.339l15.12 5.64Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M75.018 67.988c-.915 5.316-5.483 9.4-11.007 9.452a11.093 11.093 0 0 1-4.598-.944l-8.392 13.79a26.522 26.522 0 0 0 12.984 3.098c13.916-.254 25.189-11.147 26.464-24.806l-15.451-.59Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "m48.436 88.71 8.416-13.8a11.386 11.386 0 0 1-4.155-8.828c0-.861.095-1.705.278-2.514L37.83 57.957a27.696 27.696 0 0 0-1.228 8.172c0 9.423 4.698 17.69 11.833 22.581Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M65.693 54.8c5.052.785 8.977 4.98 9.443 10.173l25.578 1.009v-.035c0-19.82-15.138-36.289-34.584-37.752L65.693 54.8Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72.445 118.821c-1.47-17.944 9.555-25.349 5.353-41.61-5.194-20.098-25.183-20.96-31.988-40.667-2.503-7.24-3.553-18.032 2.95-33.562l-27.265-.891a1.408 1.408 0 0 0-1.47 1.404v156.753c0 .803.66 1.416 1.47 1.369l74.704-4.16c-17.723-14.491-22.893-28.063-23.754-38.636Z",
    opacity: 0.35
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "m43.538 45.425-41.826-.42C.767 44.994 0 44.245 0 43.325V27.422c0-.92.767-1.646 1.712-1.623l36.414.868a1.668 1.668 0 0 1 1.623 1.658v13.671l3.789 3.428Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.87 32.414-27.697-.543v-1.906l27.697.579v1.87ZM33.87 36.15l-27.697-.467v-1.906l27.697.502v1.87ZM33.87 39.884 6.174 39.5V37.59l27.697.43v1.865Z",
    opacity: 0.67
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "m64.288 98.954 37.371-.803c.974-.023 1.759.78 1.759 1.782v17.395c0 1.003-.785 1.847-1.759 1.882l-39.389 1.328a1.783 1.783 0 0 1-1.847-1.806v-22.74l3.865 2.962Z",
    opacity: 0.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m67.074 113.676 29.964-.891v2.1l-29.964.933v-2.142ZM67.074 109.398l29.964-.82v2.1l-29.964.862v-2.142ZM67.074 105.12l29.964-.75v2.107l-29.964.785v-2.142Z",
    opacity: 0.67
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M111.514 159.074s-5.495 2.514-5.583 2.909c-.089.401 3.535-.142 5.016-.089 1.482.054 2.697-.383 2.562-1.014-.136-.626-.655-2.201-.655-2.201l-1.34.395Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "m111.308 157.05.342 2.472s.873.307 1.458-.059l.242-2.714-2.042.301Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "m137.21 157.044.644 1.027c.177.289.236.631.147.962-.224.855-.667 2.519-.856 2.956-.265.59-3.824.95-3.824.95s-.319-.449.419-.986c.738-.542 1.21-.625 1.469-1.422.26-.796.425-3.05.425-3.05l1.576-.437Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M134.537 154.442c.236.183 1.387 3.652 1.387 3.652s.372.472 1.074-.23c.702-.702.319-.313.319-.313l-.142-3.41-2.638.301Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M108.162 107.321a269.751 269.751 0 0 0 .183 23.979 271.372 271.372 0 0 0 2.715 26.653c.449.012.927.012 1.416 0 .337-.012.656-.03.968-.047a61.11 61.11 0 0 0 2.025-6.521 63.425 63.425 0 0 0 1.404-7.629c1.039-8.367-.206-9.093.644-15.294.749-5.493 1.829-5.706 3.08-13.506 1.358-8.462.331-9.724-.171-10.185-2.13-1.953-7.117-.607-12.264 2.55Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M120.426 104.766c-2.03-1.859-6.663-.72-11.55 2.136 5.648 6.071 6.268 10.013 5.601 12.574-.756 2.897-3.075 3.735-3.057 6.897.017 3.889 3.535 4.909 3.47 9.022-.041 2.72-1.588 2.697-1.942 6.06-.419 3.977 1.6 5.34.95 8.284-.277 1.269-1.074 2.921-3.352 4.632.165 1.21.337 2.402.52 3.576.448.012.926.012 1.416 0 .336-.012.655-.03.968-.047a61.414 61.414 0 0 0 2.024-6.52 63.292 63.292 0 0 0 1.405-7.63c1.039-8.367-.207-9.092.643-15.294.75-5.493 1.83-5.706 3.081-13.506 1.351-8.461.324-9.724-.177-10.184Z",
    opacity: 0.3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M111.65 107.191a166.213 166.213 0 0 1 14.82 26.452 165.26 165.26 0 0 1 8.032 22.144c.254.118.856.348 1.623.248 1.045-.142 1.67-.808 1.836-.997.755-4.791.661-8.851.395-11.778-.171-1.876-.472-4.997-1.676-8.844-1.352-4.314-2.272-4.556-4.025-9.117-1.824-4.738-1.387-5.918-3.14-11.848a78.64 78.64 0 0 0-3.901-10.391c-4.651 1.375-9.307 2.756-13.964 4.131Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M91.884 97.201c.047 1.723 2.88 3.24 5.159 3.706 5.335 1.086 11.514-2.785 14.447-7.069.579-.844 1.216-1.864 1.369-1.782.349.177-2.856 5.446-4.249 11.435-.708 3.063-.525 4.502-1.853 6.538-.301.46-.673.944-.543 1.493.325 1.369 3.458 1.723 5.63 1.971 2.296.259 4.433.236 6.545.206 3.388-.047 3.654-.224 4.427.154 2.355 1.156 2.195 3.923 3.966 4.289 1.487.313 2.998-1.351 3.476-1.876 2.485-2.738 2.355-6.036 2.797-9.37 1.027-7.742 5.229-16.22 9.349-21.59 1.245-1.629 2.113-2.484 2.172-3.995.159-4.443-6.882-9.346-12.736-9.907-1.606-.153-4.48-.106-7.177.148-1.08.1-2.225.253-3.458.466-2.993.525-5.07.885-7.195 1.859-8.557 3.912-6.687 12.627-15.947 18.651-3.187 2.065-6.226 2.868-6.179 4.673Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M126.941 66.79s.366 2.047 1.216 3.51c.767 1.322 3.925 1.794 4.586 2.025.661.23-.992 1.374-2.75 1.793-1.759.413-6.894.69-7.903.136-1.009-.555.655-.72 1.865-1.357s1.611-3.216 1.239-4.314c-.383-1.109 1.747-1.793 1.747-1.793Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M123.601 66.194c-1.275-.909-1.629-3.375-.921-3.93.201-.16.396-.082 3.276 1.068 1.428.573 2.13.88 2.361 1.51.141.384.118.904-.036 1.317-.082.212-.236.472-.584.973-.307.443-.289.43-.384.56-.23.313-.667.833-1.469 1.44a5.382 5.382 0 0 0-.236-.814c-.048-.118-.231-.578-.52-.968-.501-.666-1.074-.855-1.487-1.156Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M126.871 68.537s-.832 1.245-2.379 1.073c-1.381-.153-1.452-3.268-.537-3.888.307-.206.903-.271 1.375-.118.284.094.372.213.833.354.424.13.548.089.672.2.16.142.26.485-.053 1.381.278-.253.596-.348.821-.23a.465.465 0 0 1 .177.19c.183.37-.16.808-.909 1.038Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M99.368 96.936c3.866-.874 5.407-.844 7.319-2.384 3.181-2.567 3.659-6.467 5.512-6.42.874.024 1.582.915 2.089 1.788-.466.731-.932 1.457-1.398 2.189 0-.03-.006-.047-.024-.059-.153-.077-.797.944-1.369 1.782-2.933 4.284-9.119 8.16-14.448 7.069-1.528-.313-3.305-1.098-4.32-2.1a65.764 65.764 0 0 1 6.64-1.865Z",
    opacity: 0.3
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M93.071 100.257s-2.184-.218-3.482-.773c-1.298-.554-2.142.242-2.018.797.118.555 2.26 1.322 3.11 1.351.856.024 2.39-1.375 2.39-1.375Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M140.061 111.793c2.343.207 7.614.307 11.343-3.145 6.209-5.741 3.128-16.675.968-21.371-2.478-5.388-6.421-8.409-8.817-10.238-2.974-2.272-4.786-3.664-6.97-3.351-5.648.802-9.555 12.373-6.457 15.69 1.016 1.085 2.019.471 4.958 1.403.956.307 8.097 2.579 9.337 7.836.867 3.676-1.346 7.99-5.288 10.881.307.761.613 1.528.926 2.295Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M113.804 109.887c2.65-1.675 3.045-3.375 6.014-4.52 3.86-1.492 5.713.402 7.625-1.127 2.278-1.817.26-4.991 1.965-10.49.289-.933 2.485-8.025 7.525-8.928 2.349-.419 5.453.478 6.651 2.466.939 1.558.065 2.72 1.204 4.438 1.139 1.716 2.497 1.298 3.949 2.731 2.301 2.278 2.656 7.075.578 9.789-.968 1.269-2.231 1.765-4.597 2.709a22.237 22.237 0 0 1-3.955 1.162c2.904-2.785 4.409-6.378 3.665-9.511-.773-3.275-3.842-5.394-6.273-6.597-2.432 4.579-4.421 9.883-5.082 14.875-.442 3.328-.307 6.632-2.797 9.37-.478.525-1.989 2.189-3.476 1.876-1.771-.371-1.612-3.139-3.966-4.289-.773-.378-1.039-.201-4.427-.154-2.113.03-4.255.059-6.545-.206-1.93-.219-4.615-.525-5.418-1.552 3.477-.095 5.808-1.056 7.36-2.042Z",
    opacity: 0.3
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "m138.521 113.634.271-.803c.437-1.28-.277-2.643-1.599-3.044l-51.617-15.72L84 99.397l51.358 15.813c1.316.408 2.732-.295 3.163-1.575Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M34.283 79.624c3.948-15.59 19.411-24.983 34.709-20.581 15.575 4.484 24.492 21.354 19.759 37.261-4.621 15.53-20.468 23.909-35.257 19.118-14.537-4.703-23.07-20.563-19.21-35.798ZM84.26 94.929c3.913-13.311-3.553-27.407-16.56-31.19-12.814-3.723-25.827 4.095-29.185 17.183-3.293 12.84 3.9 26.221 16.17 30.163 12.454 4.001 25.739-3.104 29.575-16.156Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DEE8",
    d: "m85.576 94.068 6.58 2.006c.455 2.1 1.328 3.298 2.213 4.036 3.323 2.756 7.767-.248 13.958 2.98 3.11 1.622 2.52 2.655 5.43 3.782 4.816 1.87 7.023-.72 11.284.979 4.308 1.723 4.733 5.441 7.183 5.311 1.044-.059 2.39-.82 3.895-3.7l1.08.331c1.316.401 2.03 1.764 1.599 3.044l-.271.803c-.431 1.274-1.848 1.982-3.158 1.575L84.012 99.402l1.564-5.334Z",
    opacity: 0.3
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.464 113.215c12.883 4.142 26.635-3.192 30.612-16.698 4.06-13.784-3.67-28.388-17.144-32.3-13.262-3.852-26.73 4.255-30.194 17.802-3.4 13.282 4.043 27.119 16.726 31.196Z",
    opacity: 0.56
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M33.28 80.963c3.948-15.59 19.41-24.983 34.708-20.581 15.575 4.484 24.493 21.354 19.76 37.262-4.622 15.53-20.468 23.908-35.258 19.117-14.53-4.708-23.064-20.563-19.21-35.798Zm49.976 15.306c3.913-13.312-3.553-27.408-16.56-31.19C53.883 61.356 40.87 69.174 37.51 82.26c-3.293 12.84 3.901 26.222 16.171 30.163 12.46 3.995 25.738-3.109 29.574-16.155Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M34.773 81.423c3.742-14.704 18.343-23.537 32.755-19.377 14.666 4.237 23.064 20.127 18.626 35.108-4.344 14.651-19.281 22.587-33.245 18.073-13.733-4.431-21.795-19.418-18.136-33.804ZM83.256 96.27c3.913-13.312-3.553-27.408-16.56-31.19-12.813-3.723-25.827 4.095-29.185 17.182-3.293 12.84 3.901 26.222 16.171 30.164 12.459 3.994 25.738-3.11 29.574-16.156Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "m139.861 111.303-.52-1.298s-.849.053-1.552-.448c-.383-.272-1.056-.354-1.251-.301-.195.053-.938.024-.094.425.844.401.838.702.484 1.032-.354.331-1.694 1.045-2.178 1.08-.484.036.389.779.879.873.484.095 1.287.219 2.272-.365.36-.213 1.96-.998 1.96-.998Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M99.304 24.33c.673.342 1.517.03 1.888-.702.372-.726.124-1.593-.549-1.936a.775.775 0 0 0-.106-.047 8.84 8.84 0 0 0 .284-1.215c.041 0 .076 0 .118-.006.767-.071 1.375-.773 1.357-1.576-.018-.802-.649-1.392-1.416-1.327l-.118.017a7.917 7.917 0 0 0-.331-1.162c.035-.018.071-.041.106-.065.655-.46.868-1.369.466-2.024-.395-.66-1.25-.82-1.906-.36a.596.596 0 0 0-.094.077 6.792 6.792 0 0 0-.85-.797c.023-.035.041-.07.059-.106.372-.726.85-1.522.177-1.853-1.57-.767-2.243-.112-2.609.62-.017.035-.035.077-.053.112a6.995 6.995 0 0 0-1.145-.218c0-.042.006-.083.006-.124-.017-.803.225-1.233-.549-1.251-1.676-.035-2.242.696-2.23 1.499 0 .041.005.082.005.124a8.185 8.185 0 0 0-1.133.419.947.947 0 0 0-.059-.107c-.395-.66-1.251-.82-1.906-.36-.655.46-.868 1.37-.466 2.024a.535.535 0 0 0 .065.095c-.29.289-.561.607-.815.944-.035-.018-.065-.042-.1-.06-.673-.341-1.517-.029-1.889.703-.372.726-.124 1.593.55 1.935.034.018.07.036.105.047a8.841 8.841 0 0 0-.283 1.216c-.041 0-.077 0-.118.006-.767.07-1.375.773-1.357 1.575.017.803.649 1.393 1.416 1.328l.118-.018c.083.396.189.785.33 1.163-.035.017-.07.041-.106.065-.655.46-.867 1.369-.466 2.023.395.661 1.712.968 2.367.508.035-.024-.396-.195-.366-.218.26.289.543.554.85.796a.955.955 0 0 0-.06.106c-.371.726-.123 1.594.55 1.936.672.342 1.516.03 1.888-.703.018-.035.035-.076.053-.112.378.107.762.177 1.145.219 0 .041-.006.082-.006.124.018.802.65 1.392 1.417 1.327.767-.07 1.375-.773 1.357-1.575 0-.041-.006-.083-.006-.124a8.197 8.197 0 0 0 1.133-.419c.018.035.036.07.06.106.395.661 1.25.82 1.906.36.655-.46.867-1.369.466-2.024a.535.535 0 0 0-.065-.094c.29-.29.56-.608.814-.944l.1.053Zm-8.38.106c-2.444-1.239-3.335-4.384-1.99-7.027 1.34-2.644 4.409-3.783 6.846-2.543 2.444 1.239 3.335 4.384 1.99 7.027-1.34 2.643-4.403 3.782-6.847 2.543Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M100.933 20.43c.767-.071 1.375-.773 1.357-1.576-.017-.802-.649-1.392-1.416-1.327l-.118.017a7.92 7.92 0 0 0-.331-1.162c.036-.018.071-.041.107-.065.655-.46 1.469-1.57 1.003-2.183-.879-1.168-1.788-.66-2.443-.2a.592.592 0 0 0-.095.076 6.783 6.783 0 0 0-.85-.796 1.541 1.541 0 0 0 .147-1.31 232.853 232.853 0 0 0-1.87 3.363c1.948 1.428 2.567 4.236 1.352 6.632-1.033 2.03-3.081 3.169-5.082 3.027-.088.23-.177.466-.271.696-.26.62-.555 1.233-.85 1.841.183.036.372.065.56.083 0 .041-.005.082-.005.124.017.802.501 1.48 1.894 1.41.767-.041.903-.856.885-1.652 0-.041-.006-.083-.006-.124a8.184 8.184 0 0 0 1.133-.42c.018.036.036.072.06.107.395.661 1.776.938 2.431.478.655-.46.342-1.487-.053-2.142a.535.535 0 0 0-.065-.094c.29-.29.56-.608.815-.944.035.017.064.041.1.059.673.342 1.517.03 1.888-.702.372-.726.124-1.594-.548-1.936-.036-.018-.071-.035-.107-.047.124-.401.219-.808.284-1.215.017-.012.059-.012.094-.018Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M100.024 24.413c.673.342 1.517.03 1.889-.703.371-.725.123-1.593-.549-1.935-.036-.018-.071-.035-.107-.047a8.84 8.84 0 0 0 .284-1.216c.041 0 .076 0 .118-.006.767-.07 1.375-.772 1.357-1.575-.018-.802-.649-1.392-1.416-1.328l-.118.018a7.914 7.914 0 0 0-.331-1.162c.036-.018.071-.041.106-.065.656-.46.868-1.369.467-2.024-.396-.66-1.251-.82-1.907-.36a.596.596 0 0 0-.094.077 6.792 6.792 0 0 0-.85-.797c.024-.035.041-.07.06-.106.371-.726.123-1.593-.55-1.935-.672-.343-1.516-.03-1.888.702-.018.035-.036.076-.053.112a6.995 6.995 0 0 0-1.145-.218c0-.042.005-.083.005-.124-.017-.803-.649-1.393-1.416-1.328-.767.07-1.375.773-1.357 1.575 0 .042.006.083.006.124a8.202 8.202 0 0 0-1.134.42.955.955 0 0 0-.059-.107c-.395-.66-1.25-.82-1.906-.36-.655.46-.867 1.37-.466 2.024a.535.535 0 0 0 .065.095c-.29.289-.56.607-.815.944-.035-.018-.065-.042-.1-.06-.673-.342-1.517-.029-1.889.703-.371.726-.123 1.593.55 1.935.035.018.07.035.106.047a8.827 8.827 0 0 0-.284 1.216c-.041 0-.076 0-.118.006-.767.07-1.375.773-1.357 1.575.017.803.649 1.393 1.416 1.328l.118-.018a7.9 7.9 0 0 0 .33 1.162c-.035.018-.07.042-.105.065-.656.46-.868 1.37-.467 2.024.396.661 1.251.82 1.907.36a.602.602 0 0 0 .094-.077c.26.29.543.555.85.797-.024.035-.041.07-.06.106-.37.726-.123 1.593.55 1.936.672.342 1.517.03 1.888-.703.018-.035.036-.076.053-.112.378.107.762.177 1.145.219 0 .04-.005.082-.005.123.017.803.649 1.393 1.416 1.328.767-.07 1.375-.773 1.357-1.575 0-.042-.006-.083-.006-.124a8.197 8.197 0 0 0 1.134-.42c.017.036.035.072.059.107.395.66 1.25.82 1.906.36.655-.46.867-1.369.466-2.024-.018-.035-.041-.065-.065-.094.29-.29.56-.608.815-.944.035.023.07.041.1.059Zm-8.375.106c-2.443-1.24-3.334-4.384-1.989-7.028 1.34-2.643 4.41-3.782 6.847-2.543 2.443 1.24 3.334 4.384 1.988 7.028-1.34 2.643-4.408 3.782-6.846 2.543Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 33.295,
    x2: 78.775,
    y1: 50.142,
    y2: 135.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 92.034,
    x2: 30.871,
    y1: 12.607,
    y2: 112.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 24.538,
    x2: 79.006,
    y1: 124.934,
    y2: 124.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 24.538,
    x2: 79.006,
    y1: 132.463,
    y2: 132.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 24.538,
    x2: 79.006,
    y1: 139.991,
    y2: 139.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 24.537,
    x2: 51.935,
    y1: 14.761,
    y2: 14.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 24.537,
    x2: 51.935,
    y1: 18.517,
    y2: 18.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 24.537,
    x2: 51.935,
    y1: 22.274,
    y2: 22.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 78.853,
    x2: 186.22,
    y1: 2.416,
    y2: 57.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 79.122,
    x2: 186.489,
    y1: 1.893,
    y2: 57.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 148.476,
    x2: 46.934,
    y1: -1.09,
    y2: 142.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 79.226,
    x2: 165.952,
    y1: 91.888,
    y2: 84.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 150.772,
    x2: 113.587,
    y1: 82.913,
    y2: 160.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 99.822,
    x2: 58.055,
    y1: 10.989,
    y2: 91.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 107.072,
    x2: 43.302,
    y1: 9.656,
    y2: 114.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 49.748,
    x2: 55.452,
    y1: 36.217,
    y2: 87.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 69.692,
    x2: 92.527,
    y1: 77.291,
    y2: 123.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 36.357,
    x2: 66.941,
    y1: 58.748,
    y2: 98.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 99.818,
    x2: 75.38,
    y1: 24.235,
    y2: 58.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 25.834,
    x2: 2.322,
    y1: 22.988,
    y2: 100.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 54.411,
    x2: 88.48,
    y1: 145.321,
    y2: 97.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 108.83,
    x2: 110.238,
    y1: 150.412,
    y2: 167.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 112.381,
    x2: 112.089,
    y1: 160.082,
    y2: 142.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 134.642,
    x2: 136.049,
    y1: 148.323,
    y2: 165.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 136.04,
    x2: 135.748,
    y1: 159.699,
    y2: 141.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 108.013,
    x2: 121.328,
    y1: 130.926,
    y2: 130.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 108.013,
    x2: 121.327,
    y1: 130.927,
    y2: 130.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 111.707,
    x2: 138.51,
    y1: 129.605,
    y2: 129.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 134.008,
    x2: 103.817,
    y1: 69.004,
    y2: 118.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 127.88,
    x2: 125.036,
    y1: 68.372,
    y2: 93.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 128.652,
    x2: 124.641,
    y1: 74.222,
    y2: 62.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 125.32,
    x2: 127.554,
    y1: 65.485,
    y2: 83.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 92.725,
    x2: 114.288,
    y1: 94.61,
    y2: 94.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 88.136,
    x2: 92.284,
    y1: 99.041,
    y2: 101.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 150.348,
    x2: 120.157,
    y1: 78.954,
    y2: 128.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 106.435,
    x2: 150.675,
    y1: 101.448,
    y2: 101.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 84.004,
    x2: 138.922,
    y1: 104.697,
    y2: 104.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 33.354,
    x2: 90.019,
    y1: 87.365,
    y2: 87.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 54.038,
    x2: 63.147,
    y1: 119.206,
    y2: 77.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 67.591,
    x2: 54.878,
    y1: 57.973,
    y2: 114.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 135.903,
    x2: 138.132,
    y1: 115.027,
    y2: 109.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 74.996,
    x2: 116.452,
    y1: 10.057,
    y2: 31.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 75.101,
    x2: 116.557,
    y1: 9.855,
    y2: 31.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 101.879,
    x2: 62.672,
    y1: 8.703,
    y2: 64.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.778268afbf4129390a7e14e3385ec0ff.svg";
export { ForwardRef as ReactComponent };